import { useEffect, useState } from "react";
import { Contract } from "../../../types/contract";
import { useCustomFields } from "../../custom-fields/CustomFieldsHook";
import { ModuleField } from "../../../types/custom-fields/module-field";
import { buildModuleFields } from "../../../utils/custom-fields";

export function useContractCustomFields(contract: Contract | undefined): { fields: ModuleField[] | undefined } {
  const { get } = useCustomFields()
  const [fields, setFields] = useState<ModuleField[]>()

  useEffect(() => {
    if (contract) {
      get().then(result => {
        buildModuleFields(contract.customFieldsDefinition ?? [], result).then(setFields)
      })
    }
  }, [get, contract])

  return { fields }
}